import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getPointsRuleAttention, type PointsRuleOwner } from '@/entities/expert-report';
import { RAW_INTERPOLATION, toastWarning } from '@/shared/lib';
import type { PointsRuleOwnerKind } from './pointsRuleOwnerKind';

/**
 * Предупреждение о правиле расчёта после сохранения, изменившего состав или названия вложенных
 * элементов: правило ссылается на них по названиям и само за ними не меняется.
 *
 * Предупреждают о том же, о чём говорит отметка в дереве: правило владельца требует внимания —
 * стало неприменимым либо считает результат не по всему составу вложенных. Владельцев берут
 * из ответа сервера, поэтому правка, вернувшая состав и названия к ожидаемому правилом виду,
 * предупреждения не даёт. Сохранение предупреждение не отменяет.
 */
export const usePointsRuleChangeWarning = (ownerKind: PointsRuleOwnerKind = 'block') => {
  const { t } = useTranslation('expertReport');

  return useCallback(
    (owners: (PointsRuleOwner | null | undefined)[]) => {
      const names = Array.from(
        new Set(owners.flatMap((owner) => (owner && getPointsRuleAttention(owner) ? [owner.name] : []))),
      );
      if (!names.length) return;
      toastWarning(t('pointsRuleCheckNeeded'), {
        description: t(
          ownerKind === 'group' ? 'km.pointsRuleCheckNeededDescription' : 'pointsRuleCheckNeededDescription',
          { ownerNames: names.join(', '), ...RAW_INTERPOLATION },
        ),
      });
    },
    [ownerKind, t],
  );
};
